import { Link } from 'react-router-dom';
import { movieCategories, siteInfo } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-1/3">
            <Link to="/" className="inline-flex items-center gap-2 whitespace-nowrap cursor-pointer">
              <span className="text-2xl font-heading font-bold text-primary-500 tracking-wider">
                97<span className="text-foreground-50">影院</span>
              </span>
            </Link>
            <p className="mt-3 text-sm text-foreground-400 leading-relaxed max-w-sm">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-300 hover:text-primary-500 hover:bg-primary-500/10 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-300 hover:text-primary-500 hover:bg-primary-500/10 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 text-foreground-300 hover:text-primary-500 hover:bg-primary-500/10 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-6">
            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-3">电影分类</h4>
              <ul className="space-y-2">
                {movieCategories.slice(0, 6).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-3">快速链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
                </li>
                <li>
                  <Link to="/category/action" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">动作片</Link>
                </li>
                <li>
                  <Link to="/category/scifi" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">科幻片</Link>
                </li>
                <li>
                  <Link to="/category/comedy" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">喜剧片</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-3">联系我们</h4>
              <ul className="space-y-2">
                <li className="text-sm text-foreground-400">邮箱：{siteInfo.email}</li>
                <li className="text-sm text-foreground-400">电话：{siteInfo.phone}</li>
                <li className="text-sm text-foreground-400">地址：{siteInfo.address}</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">{siteInfo.copyright}</p>
          <p className="text-xs text-foreground-500">{siteInfo.icp}</p>
        </div>
      </div>
    </footer>
  );
}